<template>
  <q-input
    ref="input"
    :label="label"
    :value="value"
    :rules="rules"
    :disable="disable"
    :clearable="clearable"
    :error="error"
    :error-message="errorMessage"
    lazy-rules
    outlined
    hide-bottom-space
    @input="dateChanged"
  >
    <template v-slot:append>
      <q-icon name="event" class="cursor-pointer">
        <q-popup-proxy ref="date-picker">
          <q-date
            ref="datepicker"
            v-bind="$attrs"
            :options="options"
            :value="value"
            :mask="settings.date_format"
            @input="dateChanged"
          />
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    label: String,
    value: [Date, String],
    disableCloseOnClick: Boolean,
    options: [Function, Array],
    rules: Array,
    clearable: Boolean,
    disable: Boolean,
    error: Boolean,
    errorMessage: String
  },
  methods: {
    dateChanged(newDate) {
      this.$emit('input', newDate)
      if (!this.disableCloseOnClick) {
        this.$refs['date-picker'].hide()
      }
    },
    hasErrors() {
      this.$refs.input.validate()
      return this.$refs.input.hasError
    }
  }
}
</script>
